module.exports = __webpack_public_path__ + "img/service.4bfc9933.png";